export const formatSimpleValue = (value: any): string => {
  if (value === undefined || value === null || value === '') {
    return 'Not specified';
  }
  return value.toString();
};
